'use es6';

import { createStore, applyMiddleware, combineReducers, compose } from 'redux';
import thunk from 'redux-thunk';
import sentry from 'SalesContentIndexUI/data/utils/sentry';
import SelectionReducer from './reducers/SelectionReducer';
import { SEARCH_FETCH_SUCCEEDED } from '../constants/ActionTypes';
import getEarlyRequestData from './getEarlyRequestData';
export default ((initialReducers, ...middleware) => {
  const createStoreWithMiddleware = compose(applyMiddleware(sentry, thunk, ...middleware))(createStore);
  const reducer = combineReducers(Object.assign({
    selectionData: SelectionReducer
  }, initialReducers));
  const store = createStoreWithMiddleware(reducer, window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__({
    instanceId: `sales-content-index-ui-${new Date().getTime()}`,
    name: 'Sales Content Index UI'
  }) : f => f);
  const earlyRequestData = getEarlyRequestData();
  if (earlyRequestData) {
    store.dispatch({
      type: SEARCH_FETCH_SUCCEEDED,
      payload: earlyRequestData
    });
  }
  return store;
});